import React, { useEffect, useRef, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import { Typography, TableContainer, Table, TableHead, TableRow, TableCell, Tooltip, TableBody, IconButton, FormControlLabel, Checkbox, Button, Grid, Divider, Box } from '@mui/material'
import ReactToPrint from 'react-to-print';

export default function Especiales({ especiales, removeEstudiosEspeciales, datosPaciente, datosSiscom }) {
    const componentRef = useRef();

    const [check22, setCheck22] = useState(false)

    const handleCheck = () => {
        setCheck22(!check22)
    }

    useEffect(() => {
        console.log(datosPaciente)
        console.log(datosSiscom)
        console.log(especiales)
    }, [datosPaciente, datosSiscom, especiales])



    return (
        <>
            <Divider />
            {
                especiales !== null &&
                <>

                    {
                        check22 &&
                        <>
                            <Grid container>
                                {/* <Grid item lg={12}>
                                    <Button variant='contained' sx={{ float: "right", marginRight: "20px" }}>Imprimir</Button>
                                </Grid> */}
                                <Grid item lg={12}>
                                    <ReactToPrint
                                        trigger={() => (
                                            <Grid item lg={12}>
                                                <Button variant='contained' sx={{ float: "right", marginRight: "20px" }}>
                                                    Imprimir
                                                </Button>
                                            </Grid>
                                        )}
                                        content={() => componentRef.current}
                                    />
                                    <div style={{ display: "none" }}>
                                        <div
                                            ref={componentRef}
                                            style={{
                                                width: 255,
                                                maxWidth: 255,
                                                fontFamily: "Verdana",
                                                padding: "0 1rem 0 1rem",
                                                marginRight: "10px"
                                            }}>
                                            <Box style={{ display: "flex" }}>
                                                <Box>
                                                    <Grid container spacing={1} >
                                                        <Grid style={{ textAlign: "right", marginLeft: "55px" }} item lg={12}>
                                                            <img alt="Auth0" src={'/static/images/img/logoLogin.png'} width={150} />
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                                <Box>
                                                    <Typography>Examenes Especiales</Typography>
                                                </Box>

                                            </Box>

                                            <Box>
                                                <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                                                    <Grid item xs={12}>
                                                        <div style={{ fontSize: "10px" }}>CALLE JOSEPH THOMPSON 140</div>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                            <Box >
                                                <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                                                    <Grid item xs={12}>
                                                        <div style={{ fontSize: "10px" }}>URB. SANTO THOMAS SAN BORJA</div>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                            <Box style={{ marginTop: "15px" }}>
                                                <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                                                    <Grid item xs={12}>
                                                        <div style={{ fontSize: "12px" }}><b>FECHA:</b>{" "}{
                                                            (new Date()).getDate() + "-" + ((new Date()).getMonth() + 1) + "-" + (new Date()).getFullYear() + " " +
                                                            (new Date()).getHours() + ":" + (new Date()).getMinutes()
                                                        }</div>

                                                    </Grid>
                                                </Grid>
                                            </Box>
                                            <Box >
                                                <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                                                    <Grid item xs={12}>
                                                        <div style={{ fontSize: "12px" }}><b>PACIENTE:</b>{" "}{`${datosPaciente.Des_Nombres} ${datosPaciente.Des_ApePaterno} ${datosPaciente.Des_ApeMaterno}`}</div>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                            <Box>
                                                <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                                                    <Grid item xs={12}>
                                                        <div style={{ fontSize: "12px" }}><b>EDAD:</b>{" "}{new Date().getFullYear() - parseInt(datosPaciente.Fec_Nacimien.split('T')[0].split('-')[0])} años</div>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                            {/* <Box >
                                                <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                                                    <Grid item xs={12}>
                                                        <div style={{ fontSize: "12px" }}><b>{tipoDocumentosSistComp.find(x => x.id === props.datosUsuario.Cod_TipIdenti).title}:</b>{" "}{`${props.datosUsuario.Nro_DocIdenti}`}</div>
                                                    </Grid>
                                                </Grid>
                                            </Box> */}
                                            <Box >
                                                <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                                                    <Grid item xs={12}>
                                                        <div style={{ fontSize: "12px" }}><b>Nro HC:</b>{" "}{`${datosPaciente.Nro_Historia}`}</div>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                            <Box >
                                                <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                                                    <Grid item xs={12}>
                                                        <Box style={{ display: "flex", justifyContent: "left", justifyItems: "left", alignContent: "left", alignItems: "left" }}>
                                                            <div style={{ fontSize: "12px" }}><b>Nro de Autorización:</b>{" "}{`${datosSiscom.nroAtencio}`}</div>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Box>

                                            <Box >
                                                <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                                                    <Grid item xs={12}>
                                                        <Box style={{ display: "flex", justifyContent: "left", justifyItems: "left", alignContent: "left", alignItems: "left" }}>
                                                            <div style={{ fontSize: "12px" }}><b>Financiadora:</b>{" "}{`${datosSiscom.financiadora}`}</div>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                            {/* <Grid contain2 */}
                                            <Grid container alignItems="left" justifyContent={"left"} spacing={0} sx={{ my: 0, mt: 1.5 }} >
                                                <Grid style={{ textAlign: "left" }} item lg={12}>
                                                    <div><b style={{ fontSize: "10px !important" }}>EXÁMENES AUXILIARES</b></div>
                                                </Grid>
                                            </Grid>

                                            {/* {
                                                (props.datos[0].id === "ee" || props.datos[0].id === "eco01") ?
                                                    <Grid container alignItems="left" justifyContent={"left"} spacing={0} sx={{ my: 0, mt: 0 }} >
                                                        <Grid style={{ textAlign: "left" }} item lg={12}>
                                                            <Typography sx={{ fontSize: 14 }}><b>{props.datos[0].id === "ee" ? <Typography style={{ fontFamily: "Verdana" }}><b>Consultorio: 501</b></Typography> : <Typography style={{ fontFamily: "Verdana" }}><b>Consultorio: 101</b></Typography>}</b></Typography>
                                                        </Grid>
                                                    </Grid> : null
                                            } */}

                                            <Grid container spacing={0} sx={{ ml: 0.5, mt: 1 }} >
                                                <Grid item lg={2}>
                                                    <div sx={{ fontSize: 11.5 }}><b>Diagnostico Presuntivo:</b></div>
                                                </Grid>


                                            </Grid>

                                            <Box sx={{ ml: 1 }}>
                                                <Typography>{`${especiales.infEspeciales}`}</Typography>
                                            </Box>



                                            <Grid container spacing={0} sx={{ ml: 0.5, mt: 1 }} >
                                                <Grid item lg={2}>
                                                    <div sx={{ fontSize: 11.5 }}><b>Informe Médico:</b></div>
                                                </Grid>


                                            </Grid>

                                            <Box sx={{ ml: 1 }}>
                                                <Typography>{`${especiales.impEspeciales}`}</Typography>
                                            </Box>


                                            <Grid container spacing={0} sx={{ ml: 0.5, mt: 1 }} >
                                                <Grid item lg={2}>
                                                    <div sx={{ fontSize: 11.5 }}><b>Examen Solicitado:</b></div>
                                                </Grid>


                                            </Grid>

                                            <Box sx={{ ml: 1 }}>
                                                <Typography>{`${especiales.infExamenEspeciales}`}</Typography>
                                            </Box>


                                            <Grid container spacing={0} sx={{ ml: 0.5, mt: 1 }} >
                                                <Grid item lg={2}>
                                                    <div sx={{ fontSize: 11.5 }}><b>Código de Estudio:</b></div>
                                                </Grid>


                                            </Grid>

                                            <Box sx={{ ml: 1 }}>
                                                <Typography>{`${especiales.impExamenEspeciales}`}</Typography>
                                            </Box>


                                            <Box style={{ marginTop: "80px", marginLeft: "-20px", display: "flex", flexDirection: "column", justifyContent: "center", justifyItems: "center", alignContent: "center", alignItems: "center" }}>
                                                <Typography>______________________________</Typography>
                                                <Typography style={{ fontFamily: "Verdana", fontSize: "12px" }}><b>Firma y Sello</b></Typography>
                                            </Box>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>




                        </>
                    }
                    <TableContainer style={{ padding: "15px" }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{''}</TableCell>
                                    <TableCell>Tipo Estudio</TableCell>
                                    <TableCell>Información Clínica</TableCell>
                                    <TableCell>Información Diagnóstica</TableCell>
                                    <TableCell>Nombre Estudio</TableCell>
                                    <TableCell>Código</TableCell>
                                    <TableCell>Acciones</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>


                                <TableRow hover >
                                    <TableCell>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={check22}
                                                    name="terms"
                                                    color="primary"
                                                    onChange={handleCheck}
                                                />
                                            }
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Typography
                                            noWrap
                                            variant="subtitle1"
                                            color="text.primary">
                                            <b>Examen Especial</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography
                                            noWrap
                                            variant="subtitle1"
                                            color="text.primary">
                                            <b>{especiales.infEspeciales}</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography
                                            noWrap
                                            variant="subtitle1"
                                            color="text.primary">
                                            <b>{especiales.infExamenEspeciales}</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography
                                            noWrap
                                            variant="subtitle1"
                                            color="text.primary">
                                            <b>{especiales.infExamenEspeciales}</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography
                                            noWrap
                                            variant="subtitle1"
                                            color="text.primary">
                                            <b>{especiales.impExamenEspeciales}</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Tooltip title={('Eliminar')} arrow>
                                            <IconButton
                                                size="small"
                                                color="secondary"
                                                onClick={removeEstudiosEspeciales}>
                                                <CloseIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>


                            </TableBody>
                        </Table>

                    </TableContainer>
                </>


            }

        </>
    )
}
